import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202510",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 71865,
  clicks: 1605,
  adsSpendDollars: 3309,
  budgetDollars: 3400,
  salesDollars: 11184,
  bestEstimateRoas: 3.38,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.97,
  newCustomersAcquired: 22,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
